import React, {SVGProps} from 'react';
import {ReactComponent} from '../../assets/svg/zip-code.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;